import { useEffect, useRef } from "react";

// eslint-disable-next-line
export const useEffectAvoidFirst = (
  fn: () => void,
  deps: ReadonlyArray<any>,
) => {
  const firstRenderRef = useRef(true);
  useEffect(() => {
    if (firstRenderRef.current) {
      firstRenderRef.current = false;
    } else {
      fn();
    }
  }, deps);
};
